import React from 'react';
import RecentWins from '../Hub/RecentWins';

/**
 * Widget wrapper for RecentWins
 * Shows recently completed tasks
 */
export default function RecentWinsWidget({ 
  entries = [], 
  onOpenFull, 
  onClearWins 
}) {
  return (
    <RecentWins
      entries={entries}
      onOpenFull={onOpenFull}
      onClearWins={onClearWins}
    />
  );
}
